export const CloudWatch = class {}
